import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faChartPie, faTemperatureHigh, faClock } from '@fortawesome/free-solid-svg-icons';
import React from "react";

const StampingAndOnBlock = (props) => (
    <Col xs='12' sm='6' md='4'>
      <div className="i4AndOn bg-dark">
        <div className="i4AndOnHead">
          <h3>{props.machineName}</h3>
          <p>{props.partName}</p>
          <p><small>{props.userName}</small></p>
        </div>
        <div className="i4AndOnBody">
          <ul>
            <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>{props.downTime}</li>
            <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>{props.rQty}</li>
            <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>{props.oee}</li>
            <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>{props.oilTemp}°</li>
            <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>{props.metalTemp}°</li>
            <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>{props.dieTemp}°</li>
          </ul>
        </div>
        <div className="i4AndOnFooter">
          <ul>
            <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
            <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
            <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
            <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
          </ul>
        </div>
      </div>
    </Col>
);

export default StampingAndOnBlock;
